
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Actions, Select, Store, ofActionSuccessful } from '@ngxs/store';
import { NotesModel, TourModel, VehicleEventsModel, VehicleModel } from '@core/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Observable, Subject } from 'rxjs';
import { GetNotesAction, GetRouteByTourIdAction, GetTourByIdAction, GetTourByIdSuccessAction } from '@ngxs-store/managed-tour-store/managed-tour.actions';
import { Location } from '@angular/common';
import { GetVehicleByIdAction, GetVehicleEventsAction, GetVehicleLocFromEventAction } from '@ngxs-store/vehicles-store/vehicles.action';
import { VehiclesState } from '@ngxs-store/vehicles-store/vehicles.state';
import { ManagedToursState } from '@ngxs-store/managed-tour-store/managed-tour.state';
import { DataSourceConfig } from '@core/models';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { LatLngLiteral } from '@agm/core';


@Component({
  selector: 'app-view-my-tour-details',
  templateUrl: './view-my-tour-details.component.html',
  styleUrls: ['./view-my-tour-details.component.scss']
})
export class MyViewTourDetailsComponent implements OnInit, OnDestroy {
  @Select(VehiclesState.getVehicleEventsByTourId) vehicleHistory$: Observable<VehicleEventsModel[]>;
  @Input() vehicleHistory: VehicleEventsModel[];

  @Select(VehiclesState.getVehicleLocFromEvent) vehicleLoc$: Observable<VehicleEventsModel>;
  @Input() vehicleLoc: VehicleEventsModel;

  @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  detail: TourModel;
  vehicleDet: VehicleEventsModel;
  notes: NotesModel[] = [];
  lat: number;
  lng: number;
  imageUrl: string;
  //collection and vehicleId
  collectionLat: number;
  collectionLng: number;
  vehicleId: number;
  routeData: string = '';
  mapCenter: LatLngLiteral = { lat: 48.858093, lng: 2.294694 };
  markers: Array<{ lat: number; lng: number; }>=[];
  polylinePoints: Array<{ lat: number; lng: number }> = [];
  redPolylinePoints: Array<{ lat: number; lng: number }> = [];
  vehicleEventMarkers: VehicleEventsModel[] = [];
  vehicleEventPolylinePoints: Array<{ lat: number; lng: number }> = [];
  private unsubscribe$ = new Subject();
  selectedFilterBy: string = '';
  hasCustomerRole: boolean = false;
  transportOrderNumber: string | null = null;

  dataSource: MatTableDataSource<VehicleEventsModel>;

  dataSourceConfig: DataSourceConfig = {
    name: 'audit-table',
    columns: [
    'positionDateTime',
    'address',
    'countryCode',
    'zipCode',
    'nearestCity',
    'isManual'],
    desktopModeColumns: [],
    mobileModeColumns: [],
    pageIndex: 10,
    pageSize: 10,
    pageSizeOptions: [10, 50, 100],
    filter: '',
    filterColumns: ['address', 'countryCode'],
    selectedFilterColumns: ['address'],
    sortBy: '',
    sortByOrder: ''
};

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private actions$: Actions,
    private location: Location,
    private cdr: ChangeDetectorRef
  ) {
    const s = this.route.params.subscribe(params => {
      // Access the optional parameter from the route
      if (params['filter']) {
          this.selectedFilterBy = params['filter'];
      }
      if (params['transportOrderNumber']) {
          this.transportOrderNumber = params['transportOrderNumber'];
      }
    });

    const token = this.store.selectSnapshot(AuthState.getDecodedToken);

    if(token.roles.findIndex((hasRoleFn) => hasRoleFn === 'Customer') > -1){
        this.hasCustomerRole = true;
    }else{
        this.hasCustomerRole = false;
    }

   }



   ngOnInit() {

    this.dataSource = new MatTableDataSource<VehicleEventsModel>();

    this.vehicleHistory$.subscribe(vehicle => {
        this.vehicleHistory = vehicle;
        this.dataSource.data = vehicle;
      this.updateVehicleEventMapLayers(vehicle);
    });

    this.route.params.subscribe(params => {
      const tourId = +params['id'];

    if (params['transportOrderNumber']) {
      this.transportOrderNumber = params['transportOrderNumber'];
    }

      const sub = this.actions$
        .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
        .subscribe((detail) => {
          this.detail = detail.payload;
          this.transportOrderNumber = this.detail?.transportOrderNumber ?? this.transportOrderNumber;

          if (this.detail && this.detail.id) {
            const id = this.detail.id;
            this.lat = this.detail.destinationLatitude;
            this.lng = this.detail.destinationLongitude;
            this.markers.push({
                lat: this.detail.destinationLatitude,
                lng: this.detail.destinationLongitude,
            })
            this.collectionLat = this.detail.collectionLatitude;
            this.collectionLng = this.detail.collectionLongitude;
            this.markers.push({
                lat: this.detail.collectionLatitude,
                lng: this.detail.collectionLongitude,
            })

            // Get vehicle by vehicleId from tour
            this.store.dispatch(new GetVehicleLocFromEventAction(this.detail.id));

            this.store.select(VehiclesState.getVehicleLocFromEvent).subscribe(vehicleDet => {
              this.vehicleDet = vehicleDet;
            });

            //Get notes
            this.store.dispatch(new GetNotesAction(id));

            // Get latest route
            this.store.dispatch(new GetRouteByTourIdAction(id));
            this.store.select(ManagedToursState.getRouteByTourId).subscribe(vehicleDet => {
                this.routeData = vehicleDet?.routeData;
              });

            if (this.routeData) {
                try {
                  const routeArray = JSON.parse(this.routeData);
                  this.markers.push(routeArray.map(point => ({
                    lat: point.lat,
                    lng: point.lng,
                  })));
                  // Extracting latitude and longitude from the parsed array
                  this.polylinePoints = routeArray.map(point => ({
                    lat: point.lat,
                    lng: point.lng,
                  }));

                } catch (error) {
                  console.error('Error parsing routeData:', error);
                }
            }


            //Get vehicle events & plot
            this.store.dispatch(new GetVehicleEventsAction(id));
            this.store.select(VehiclesState.getVehicleEventsByTourId).subscribe(events => {
                this.redPolylinePoints = events.map(event => ({
                  lat: event.latitude,
                  lng: event.longitude,
                }));
                this.updateVehicleEventMapLayers(events);
              });
              this.redPolylinePoints.forEach(point => {
                this.markers.push(point);
                });
                console.log(this.markers);
                if (this.markers.length) {
                  const sumLat = this.markers.reduce((sum, marker) => sum + marker.lat, 0);
                  const sumLng = this.markers.reduce((sum, marker) => sum + marker.lng, 0);

                  // Calculate the average latitude and longitude
                  this.mapCenter.lat = sumLat / this.markers.length;
                  this.mapCenter.lng = sumLng / this.markers.length;
                }else{
                  this.mapCenter= { lat: 48.858093, lng: 2.294694 };
                }
          }
          sub.unsubscribe();
        });

  this.store.dispatch(new GetTourByIdAction(tourId, this.transportOrderNumber));

      this.store.select(state => state.Tour.notes).subscribe(notes => {
        this.notes = notes;
      });
    });
  }



  resetMap(){
    this.polylinePoints = [];
    this.redPolylinePoints = [];
    this.routeData = '';

    this.polylinePoints = [...this.polylinePoints];
    this.redPolylinePoints = [...this.redPolylinePoints];
  }


  getTruckIcon(planned: string, eta?: Date, actual?: Date): string {
    const plannedDate = new Date(planned);
    const etaOrActual = eta || actual;

    if (!etaOrActual) {
        // No ETA or actual time entered
        return './assets/images/amco-main-bw.png';
    }

    if (etaOrActual > plannedDate) {
        // ETA or actual time is after the planned time
        return './assets/images/amco-green-truck.png';
    }

    // ETA or actual time is before or on the planned time
    return './assets/images/amco-green-truck.png';
}

    getCollectionIcon(planned: string, eta?: Date, actual?: Date, type?: string): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;
        const ActualDateTime = actual;
        const ETA = eta;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return './assets/images/collect-base.png';
        }

        if(type == "Delivery"){
            if (ActualDateTime > plannedDate) {
                // ETA or actual time is after the planned time
                return './assets/images/collect-1.png';
            }else{
                return './assets/images/collect-2.png';
            }
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return './assets/images/collect-1.png';
        }

        // ETA or actual time is before or on the planned time
        return './assets/images/collect-2.png';
    }

    getDeliveryIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return './assets/images/delivery-base.png';
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return './assets/images/delivery-1.png';
        }

        // ETA or actual time is before or on the planned time
        return './assets/images/delivery-2.png';
    }

  getTimeDifference(targetDateTime: string, ETADateTime: Date): string {
    const targetDate = new Date(targetDateTime);

    if (!ETADateTime) {
        //no eta then Delta should be blank
        return '';
    } else {
        // If ETA exists, calculate time difference between ETA and planned end
        const ETADate = new Date(ETADateTime);
        const timeDifference = Math.abs(ETADate.getTime() - targetDate.getTime());
        const minutesDifference = Math.floor(timeDifference / (1000 * 60));

        const hours = Math.floor(minutesDifference / 60);
        const minutes = minutesDifference % 60;

        if (hours === 0 && minutes === 0) {
            return '0 hrs';
        }

        let timeDifferenceString = '';

        if (hours > 0) {
            timeDifferenceString += hours + 'hr ';
        }
        if (minutes > 0) {
            timeDifferenceString += minutes + 'min';
        }

        return timeDifferenceString.trim();
    }
  }

  onMapReady(map: any): void {
    const trafficLayer = new google.maps.TrafficLayer();
    trafficLayer.setMap(map);
  }

  private updateVehicleEventMapLayers(events: VehicleEventsModel[] = []): void {
    const sortedEvents = [...events]
      .filter((event) => event?.latitude != null && event?.longitude != null)
      .sort((a, b) => {
        const timeA = new Date(a.positionDateTime as any).getTime();
        const timeB = new Date(b.positionDateTime as any).getTime();

        if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
          return 0;
        }

        if (Number.isNaN(timeA)) {
          return 1;
        }

        if (Number.isNaN(timeB)) {
          return -1;
        }

        return timeA - timeB;
      });

    this.vehicleEventMarkers = sortedEvents;
    this.vehicleEventPolylinePoints = sortedEvents.map((event) => ({
      lat: event.latitude as number,
      lng: event.longitude as number,
    }));
  }

  getVehicleEventTitle(event: VehicleEventsModel): string {
    const parts: string[] = [];

    if (event.vehicleLicensePlate) {
      parts.push(`Reg: ${event.vehicleLicensePlate}`);
    }

    if (event.positionDateTime) {
      parts.push(`Date: ${new Date(event.positionDateTime as any).toLocaleString()}`);
    }

    if (event.nearestCity) {
      parts.push(`City: ${event.nearestCity}`);
    }

    if (event.addressInfo) {
      parts.push(`Address: ${event.addressInfo}`);
    }

    return parts.join('\n') || 'Vehicle Event';
  }

  goBack() {
    if (this.selectedFilterBy) {
      this.store.dispatch(new Navigate(['/my-active-tours/', {filter:this.selectedFilterBy}]));
    } else {
      this.location.back();
    }
    this.resetMap();

    this.cdr.detectChanges();
  }

  page(pageEvent: PageEvent) {
    this.updateDataSourceConfig.emit({ ...this.dataSourceConfig, pageIndex: pageEvent.pageIndex, pageSize: pageEvent.pageSize });
  }

  sortChange(sortEvent: Sort) {
    this.updateDataSourceConfig.emit({ ...this.dataSourceConfig, sortByOrder: sortEvent.direction, sortBy: sortEvent.active });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  getIcon(type: string,updatedBy:string): string {

    if (updatedBy =='ImportService') {

        return type=='Collection'?'./assets/images/White-C.png' : './assets/images/White-D.png';

    }else {

        return type=='Collection'?'./assets/images/Green-C.png' : './assets/images/Green-D.png';

    }
}
}
